import { render } from "./message-robot-welcome.vue?vue&type=template&id=45ab90ff&ts=true"
import script from "./message-robot-welcome.vue?vue&type=script&lang=ts"
export * from "./message-robot-welcome.vue?vue&type=script&lang=ts"

import "./message-robot-welcome.vue?vue&type=style&index=0&id=45ab90ff&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__